export enum Role {
  SUPERADMIN = 'SUPERADMIN',
  ADMIN = 'ADMIN',
  TEACHER = 'TEACHER',
  STUDENT = 'STUDENT',
  PARENT = 'PARENT'
};

export interface User {
  id: number
  username: string
  password: string
  email: string
  role: string
  firstName: string | null
  lastName: string | null
  isEmailConfirmed: boolean
  otpEmailSecret: string | null
  createdAt: Date
  updatedAt: Date
  comments?: Comment[]
}

export interface Comment {
  id: number
  content: string
  userId: number
  createdAt: Date
  commenter: User
  user: User
}
